import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import MapContainer from "./container/MapContainer";
import { useAllContexts } from "../../hooks/useAllContexts";

const Map = ({ mapFrame }) => {
  const { search } = useLocation();
  const typeIdFromURL = new URLSearchParams(search).get("typeId");

  const { meteo, allSensors, parking } = useAllContexts();

  const [refreshData, setRefreshData] = useState(false);
  const [visibleData, setVisibleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewRouteForm, setShowNewRouteForm] = useState(false);
  const [mapSelectedCategory, setMapSelectedCategory] = useState("infra");

  const refresh = () => setRefreshData((prev) => !prev);

  const handleLoading = () => {
    const loadingStates = {
      5: meteo.loading,
      24: parking.loadingParkingDetails,
      31: allSensors.loading,
    };
    setLoading(loadingStates[typeIdFromURL] || false);
  };

  useEffect(() => {
    handleLoading();
  }, [typeIdFromURL, mapSelectedCategory, meteo.loading]);

  const getVisibleData = useMemo(() => {
    const dataMap = {
      5: meteo?.meteoInfoData,
      24: parking?.parkingDetailsData,
      31: allSensors?.allSensorsData?.[31]?.data ?? [],
    };
    return dataMap[typeIdFromURL] || [];
  }, [
    typeIdFromURL,
    mapSelectedCategory,
    showNewRouteForm,
    meteo.meteoInfoData,
    allSensors.allSensorsData,
    parking.parkingDetailsData,
  ]);

  useEffect(() => {
    setVisibleData(getVisibleData);
  }, [getVisibleData, refreshData]);

  return (
    <MapContainer
      data={visibleData}
      loading={loading}
      categoryId={typeIdFromURL}
      selectedCategory={{
        get: mapSelectedCategory,
        set: setMapSelectedCategory,
      }}
      showNewRouteForm={{ get: showNewRouteForm, set: setShowNewRouteForm }}
      refresh={refresh}
    />
  );
};

export default Map;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import MapContainer from "./container/MapContainer";

// // import { cityCenter } from "../../../SMARTCITY/hardCodeData/DATA";
// // import SmartIsCityMap from "./smartiscity/SmartIsCityMap";
// // import MapAMEA from "./smartiscity/MapAMEA";

// import { useAllContexts } from "../../hooks/useAllContexts";

// // import SmartIsCityAMEA from "./smartiscity/SmartCityAMEA";

// const Map = ({ mapFrame }) => {
//   // Base initializations needed fot maps to work
//   const { search } = useLocation();
//   const typeIdFromURL = new URLSearchParams(search).get("typeId");

//   // map specific initializations for different maps
//   const { ameaInfrastructures, ameaRoutes, environment, meteo, allSensors } =
//     useAllContexts();
//   // Data in contexts
//   const { meteoInfoData } = meteo;
//   const { infrastructureData } = ameaInfrastructures;
//   const { AmeaRoutesData } = ameaRoutes;

//   const [refreshData, setRefreshData] = useState(false);
//   const [visibleData, setVisibleData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewRouteForm, setShowNewRouteForm] = useState(false);

//   // 122
//   const [mapSelectedCategory, setMapSelectedCategory] = useState("infra");

//   const refresh = () => {
//     setRefreshData(!refreshData);
//   };

//   const handleLoading = () => {
//     switch (typeIdFromURL) {
//       case "5":
//         setLoading(meteo.loading);
//         break;
//       case "31":
//         setLoading(allSensors.loading);
//         break;
//       case "122":
//         mapSelectedCategory === "infra"
//           ? setLoading(ameaInfrastructures.loading)
//           : setLoading(ameaRoutes.loading);
//         break;
//     }
//   };

//   useEffect(() => {
//     handleLoading();
//   }, [infrastructureData, AmeaRoutesData, meteoInfoData]);

//   useEffect(() => {
//     switch (typeIdFromURL) {
//       case "5":
//         setVisibleData(meteoInfoData);
//         break;
//       case "31":
//         allSensors?.allSensorsData &&
//           setVisibleData(allSensors?.allSensorsData[31]?.data ?? []);
//         break;
//       case "122":
//         mapSelectedCategory === "infra" || showNewRouteForm
//           ? setVisibleData(infrastructureData)
//           : setVisibleData(AmeaRoutesData);
//         break;
//     }
//   }, [
//     infrastructureData,
//     AmeaRoutesData,
//     meteoInfoData,
//     refreshData,
//     mapSelectedCategory,
//     showNewRouteForm,
//   ]);

//   return (
//     <MapContainer
//       data={visibleData}
//       loading={loading}
//       categoryId={typeIdFromURL}
//       selectedCategory={{
//         get: mapSelectedCategory,
//         set: setMapSelectedCategory,
//       }}
//       showNewRouteForm={{
//         get: showNewRouteForm,
//         set: setShowNewRouteForm,
//       }}
//       refresh={refresh}
//     />
//   );
// };

// export default Map;
